import { Component, Prop, Watch } from 'vue-property-decorator';
import { LocationDTO } from '../../../model/LocationDTO';
import { LocationStatsDTO } from '../../../model/LocationStatsDTO';
import { Block } from '../../../helpers/components';
import { BaseBlock } from '../../base-block';
import { ImageResourceDTO } from '../../../model/ImageResourceDTO';
import { apartmentLocationDetailsData } from './apartment-location-details.data';
import { Gallery } from '../../../components/gallery/gallery';

@Block(apartmentLocationDetailsData) @Component({
	components: {
		Gallery
	}
})
export class ApartmentLocationDetails extends BaseBlock {
	@Prop() location: LocationDTO;
	@Prop() locationStats: LocationStatsDTO;
	@Prop() projectGallery: ImageResourceDTO[][];
	@Prop() constructionGallery: ImageResourceDTO[][];
	@Prop() surroundingsGallery: ImageResourceDTO[][];

	showGalleries: boolean = false;

	get linksPricesLink() {
		var catalogNo = this.location.catalogNumber;
		if (this.location.catalogMarketingNumber) {
			catalogNo = this.location.catalogMarketingNumber;
		}

		const linksPricesLinkOrig = `/prehled-bytu/${catalogNo}`;

		if (this.$route.query.predbezne && this.$route.query.csh) {
			return `${linksPricesLinkOrig}?csh=${this.$route.query.csh}&predbezne=${this.$route.query.predbezne}`;
		}

		return linksPricesLinkOrig;
	}

	toogleGalleries() {
		this.showGalleries = !this.showGalleries;
	}

	@Watch("showGalleries")
	scrollTop(show: boolean) {
		this.$nextTick(() => {
			if (this.showGalleries) {
				var container = this.$el.querySelector("#gallery") as HTMLElement;
				window.scrollTo(0, container.offsetTop - container.offsetHeight);
			}
		});
	}
}

export default ApartmentLocationDetails;
